<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'clubList' }"> {{$t('entities.club.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>
            </el-breadcrumb>

            <h2 class="page-title"> {{$t('entities.club.singular')}}</h2>

            <el-row :gutter="20">
                <!-- Left -->
                <el-col :span="16">
                    <el-form
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.id }}</el-form-item>

                        <el-form-item :label="$t('entities.club.prop.name')">{{ model.name }}</el-form-item>

                        <el-form-item
                            :label="$t('entities.club.prop.emailManager')"
                        >{{ model.emailManager }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.club.prop.statusManager')"
                        >{{ model.statusManager }}</el-form-item>
                        <el-form-item :label="$t('entities.club.prop.logo')">
                            <img :src="model.logo.url" class="image" width="10%" height="10%">
                            <!-- <app-image-carousel :images="model.logo" /> -->
                        </el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.created')"
                        >{{ model.created | formatDatetime }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.modifiedAt')"
                        >{{ model.modified | formatDatetime }}</el-form-item>

                        <div class="button-group mt-3">
                            <el-button
                                v-if="hasRoleToUpdate"
                                icon="el-icon-fa-pencil-square-o"
                                @click="edit()"
                                type="primary"
                            >{{$t('table.edit')}}</el-button>
                            <el-button
                                v-if="hasRoleToReadLogs"
                                icon="el-icon-fa-history"
                                @click="history()"
                                type="infor"
                            >{{$t('table.history')}}</el-button>
                            <el-button
                                v-if="hasRoleToDelete"
                                icon="el-icon-fa-trash"
                                @click="destroy(model)"
                                type="danger"
                            >{{$t('table.delete')}}</el-button>
                        </div>
                    </el-form>
                </el-col>
                <!-- Rigth -->
                <el-col :span="8"
                  v-if="model.manager"
                >
                    <div class="grid-content bg-purple"></div>
                    <h3 class="page-title">{{$t('entities.manager.singular')}}</h3>
                    <el-form
                      
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.manager.id }}</el-form-item>
                        <el-form-item :label="$t('entities.manager.prop.name')">{{ model.manager.name }}</el-form-item>
                        <el-form-item :label="$t('entities.manager.prop.lastName')">{{ model.manager.lastName }}</el-form-item>
                        <el-form-item :label="$t('entities.manager.prop.email')">{{ model.manager.email }}</el-form-item>
                        <el-form-item :label="$t('entities.manager.prop.phone')">{{ model.manager.phone }}</el-form-item>
                    </el-form>
                </el-col>
            </el-row>

            <!-- * ******************** -->
            <!-- *      Team List     * -->
            <!-- ********************** -->
            <team-list :clubId="model.id"></team-list>
            <!-- <transition name="fade" mode="out-in">
          <router-view name="clubTeamNew"></router-view>
            </transition>-->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeamList from "@/entities/team/team-list";
/* eslint-disable */

export default {
    name: "app-club-show",

    components: {
        teamList: TeamList
    },

    props: {
        id: String
    },

    data() {
        return {
            title: "Información del club",
            labels: {
                name: "Nombre club",
                emailManager: "Email de contacto",
                picture: "Escudo"
            }
        };
    },

    created() {
        this.$store
            .dispatch("entities/club/detail", this.id)
            .catch(() => this.$router.push({ name: "clubList" }));
    },

    beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        /**
         * Si no estamos en detalles de club y no creamos un equipo, reseteamos el estado del club
         */
        if (from.name === "clubShow" && to.name === "teamNew") {
            next();
        } else {
            this.$store.dispatch("entities/club/clear");
            next();
        }
    },

    beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/team/list");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/club/model",
            loading: "entities/club/loading",
            hasRoleToDelete: "entities/club/hasRoleToDelete",
            hasRoleToUpdate: "entities/club/hasRoleToUpdate",
            hasRoleToRead: "entities/club/hasRoleToRead",
            hasRoleToReadLogs: "entities/club/hasRoleToReadLogs",
            hasRoleToCreate: "entities/club/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth"
        })
    },

    methods: {
        edit() {
            this.$router.push({
                name: "clubEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy(model) {
            //eslint-disable-next-line
this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
        confirmButtonText: this.$t("table.yes"),
        cancelButtonText: this.$t("table.no"),
        type: 'warning',
      })
                .then(() =>
                    this.$store.dispatch("entities/club/destroy", model)
                )
                .then(() => this.$router.push({ name: "clubList" }))
                .catch(() => {});
        },

        history() {
            this.$router.push({
                name: "clubHistorySingle",
                params: { id: this.id }
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/club/club-show.vue?70390ae6